import type { BonusStatus } from '../../../api/fetchers/bonusPromotions/types/constants';
import type { Trophy } from '../../../store/slices/promotionsV2/types';

export enum PromotionsCustomEvents {
  OnTrophyWingItem = 'ontrophywingitem',
  OnModalShow = 'onmodalshow',
  OnClaimBonus = 'onclaimbonus',
  OnBonusNotification = 'onbonusnotification',
  OnPromoEarVisible = 'onpromoearvisible',
}

/*
  This file have all the events which are exposed for clients who consume promotions as webcomponent.
*/
export const sendPromoTrophyStatusEvent = (trophy: Trophy): void => {
  const event = new CustomEvent(PromotionsCustomEvents.OnTrophyWingItem, {
    detail: trophy,
  });
  window.dispatchEvent(event);
};

export const sendModalEvent = (show: boolean): void => {
  const event = new CustomEvent(PromotionsCustomEvents.OnModalShow, {
    detail: { show },
    bubbles: true,
  });
  window.dispatchEvent(event);
};

export const sendBonusClaimEvent = (bonusId: number): void => {
  const event = new CustomEvent(PromotionsCustomEvents.OnClaimBonus, {
    detail: { bonusId: bonusId },
  });
  window.dispatchEvent(event);
};

export const sendBonusNotificationEvent = (bonusId: number, bonusStatus: BonusStatus): void => {
  const event = new CustomEvent(PromotionsCustomEvents.OnBonusNotification, {
    detail: { status: bonusStatus, id: bonusId },
  });
  window.dispatchEvent(event);
};

export const sendPromoEarEvent = (show: boolean): void => {
  const event = new CustomEvent(PromotionsCustomEvents.OnPromoEarVisible, {
    detail: { show },
    bubbles: true,
  });
  window.dispatchEvent(event);
};
